
export function isPaymentEnabled() {
    let enabled = true;
  
    if (process.env.hasOwnProperty('REACT_APP_PAYMENT_ENABLED')) {
      enabled = +process.env.PAYMENT_ENABLED === 1;
    }
  
    return enabled;
  }
  

export function formatMoneyInput(value){
  if (value === '') return ''

  // remove tudo que não for número ou ponto
  let cleaned = value.replace(/[^0-9.]/g, '')

  // garante apenas um ponto decimal
  const parts = cleaned.split('.')
  if (parts.length > 2) {
    cleaned = parts[0] + '.' + parts.slice(1).join('')
  }

  // limita a duas casas decimais
  const [integer, decimal] = cleaned.split('.')
  if (decimal !== undefined) {
    cleaned = `${integer}.${decimal.slice(0, 2)}`
  }

  return cleaned
}


export function parseToFloat(value) {
  if (value === null || value === undefined) {
    return null;
  }

  if (typeof value === 'string') {
    value = value.trim();
    if (value === '') {
      return null;
    }

    // normaliza vírgula para ponto
    value = value.replace(',', '.');
  }

  const number = Number(value);

  return Number.isFinite(number) ? number : null;
}